import { Component, OnInit, AfterViewInit } from '@angular/core';
import * as FileSaver from 'file-saver';
import { NavController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { ViewController } from 'ionic-angular';
import { SitemapService } from '../../../../../../../UI/src/app/shared/sitemap/sitemap.service';
import { ProfileService } from '../../../../../../../UI/src/app/shared/profile/profile.service';
import { ToastControllerService } from '../../../../../providers/toast-controller.service';
import { Toast508Service } from '../../../../../providers/toast-508.service';
import { HomeComponent } from '../../../home/home.component';

@Component({
  selector: 'page-gdpr-alert',
  templateUrl: 'gdpr-alert-dialog.component.html'
})
export class GDPRAlertDialogComponent implements OnInit, AfterViewInit {
  alertData: any;
  translations: any;
  public profileData: any;
  public resumeData: any;
  public profileresumeData: any;
  public showLoader = false;
  constructor(
    private profileService: ProfileService,
    public navCtrl: NavController,
    private sitemapService: SitemapService,
    private translate: TranslateService,
    private toastService: ToastControllerService,
    public viewCtrl: ViewController,
    private toast508Service: Toast508Service
  ) {
    this.translate
      .get([
        'CAREER_DELETE_ACCOUNT_WARNING_TEXT',
        'CAREER_DELETE_ACCOUNT_TEXT',
        'CAREER_DELETE_ACCOUNT_WARNING_DESCRIPTION_TEXT'
      ])
      .subscribe((obj) => {
        this.translations = obj;
      });
  }

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      let elm = <HTMLDivElement>document.querySelector('ion-modal div');
      elm.setAttribute('tabindex', '-1');
      elm.setAttribute('role', 'dialog');
      elm.focus();
    }, 300);
  }

  deleteAccount() {
    this.downloadPersonalData().then(
      (blob) => {
        FileSaver.saveAs(blob, 'PersonalData.csv');
        this.profileService.deleteAccount().subscribe(
          (response: any) => {
            this.close(true);
            this.sitemapService.removeAuthToken();            
          },
          (error) => {
            console.log(error);                        
            this.close(false);            
          }
        );
      },
      () => {
        console.log('Could not download personal data');
        this.close(false);
      }
    );
  }

  isSafariInIOS() {
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    if (isSafari && iOS) {
      return true;
    } else {
      return false;
    }
  }

  // Downloads personal data in CSV format
  downloadPersonalData(): Promise<Blob> {
    if (!this.isSafariInIOS()) {
      this.alertData = {
        message: this.translations['CAREER_DELETE_ACCOUNT_WARNING_DESCRIPTION_TEXT'],
        type: 'warning'
      };
      this.toastService.presentToast(this.alertData, 'selectFile');
      this.toast508Service.toFocus();
    }
    return this.profileService.downloadPersonalData().toPromise();
  }

  close(value) {
    this.viewCtrl.dismiss(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/edit-profile/profile/gdpr-alert/gdpr-alert-dialog.component.ts